<script setup lang="ts">
/*
 *
 * IMPORTS
 *
 * */
// Vue, Vue Router etc
import { onMounted, ref } from 'vue'

// Stores
import { useReferentialStore } from '@/presentation/stores/referential/referential.ts'
import { useLearningCoursesStore } from '@/presentation/stores/learning/learningCourses.ts'
import { LearningStatus } from '@/core/domain/resources/enums/LearningStatus.ts'

// Custom components and types

// Utility
const { fetchAllAxes } = useReferentialStore()
const learningCoursesStore = useLearningCoursesStore()

// Data
const loading = ref(true)

// Props
const props = defineProps<{
  courseId: number
}>()

// Lifecycle hooks
onMounted(async () => {
  // Fetch referential data for context if needed
  await fetchAllAxes()

  await learningCoursesStore.fetchCourse(props.courseId, {
    status: [LearningStatus.Values.ACTIVE, LearningStatus.Values.DRAFT]
  })

  loading.value = false
})
</script>

<template>
  <router-view v-if="!loading" />
</template>
